// src/contexts/AuthContext.js

import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({
        token: localStorage.getItem('token'),
        userId: localStorage.getItem('user_id'),
    });

    const loginUser = (token, userId) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user_id', userId);
        setAuth({ token, userId });
    };

    const logoutUser = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        setAuth({ token: null, userId: null });
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('user_id');
        if (token && userId) {
            setAuth({ token, userId });
        }
    }, []);

    return (
        <AuthContext.Provider value={{ auth, loginUser, logoutUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
